import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=ced3236c&scoped=true"
import script from "./DataStatistics.vue?vue&type=script&lang=js"
export * from "./DataStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataStatistics.vue?vue&type=style&index=0&id=ced3236c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced3236c",
  null
  
)

export default component.exports